export default "__VITE_ASSET__B9QS9MDm__"